var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('avp-breadcrumbs'), _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Pergunta",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.pergunta,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "pergunta", $$v);
      },
      expression: "form.filters.pergunta"
    }
  })], 1), _c('avp-select-ativo', {
    attrs: {
      "cols": 4
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('avp-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarFAQ();
      }
    }
  }), _c('avp-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('avp-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterFAQ();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listFAQ,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "show-expand": ""
    },
    scopedSlots: _vm._u([{
      key: `item.pergunta`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.pergunta) + " ")];
      }
    }, {
      key: `item.posicao`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.posicao) + "º ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('avp-label-ativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('avp-tooltip', {
          attrs: {
            "text": 'Editar FAQ',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterFAQ(item);
            }
          }
        }), _c('avp-tooltip', {
          attrs: {
            "text": 'Visualizar FAQ',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarFAQ(item);
            }
          }
        }), _c('avp-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'} FAQ`,
            "icon": `${item.ativo ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarFAQ(item);
            }
          }
        })];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref5) {
        var headers = _ref5.headers,
            item = _ref5.item;
        return [_c('td', {
          staticClass: "resposta",
          attrs: {
            "colspan": headers.length
          }
        }, [_vm._v(" " + _vm._s(item.resposta) + " ")])];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarFAQDialog', {
    attrs: {
      "visible": _vm.dialogManterFAQ.visible,
      "content": _vm.dialogManterFAQ.content,
      "edit": _vm.dialogManterFAQ.edit,
      "positions": _vm.getPosicoesFAQ
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterFAQ.close();
      },
      "onSave": function ($event) {
        return _vm.buscarFAQ();
      }
    }
  }), _c('VisualizarFAQDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarFAQ.visible,
      "content": _vm.dialogVisualizarFAQ.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarFAQ.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }